import LogoDark from './logo.dark'

export default LogoDark
